import { Maybe } from '@Types'

export const isEmptyObject = (object: object) => Object.keys(object).length === 0

export const isNotAnEmptyObject = (object: Maybe<object>): boolean => {
    if (!object) {
        return false
    }
    return Object.keys(object).length > 0
}
